import type { EmailObsEvent } from '@/features/observability/model/email-events';

const bom = { companyId: 'emp-bom-beef', companyName: 'Bom Beef' };
const tea = { companyId: 'emp-tea-shop', companyName: 'Tea Shop' };
const pad = { companyId: 'emp-padaria', companyName: 'Padaria Central' };

/** Eventos fictícios do master. Sem corpo da mensagem, segredo ou contato completo. */
export const EMAIL_OBS_EVENTS: EmailObsEvent[] = [
  {
    id: 'obs-sms-delivered',
    at: '2026-10-19T16:12:00-03:00',
    ...tea,
    channel: 'sms',
    campaignId: 'obs-sms-pontos',
    campaignName: 'Pontos perto de vencer',
    recipientMasked: '(11) 9••••-4821',
    kind: 'delivered',
    state: 'success',
    cause: null,
    subject: 'Pontos perto de vencer',
    sequence: [
      { at: '2026-10-19T16:10:00-03:00', label: 'Envio', detail: 'SMS aceito para entrega.' },
      { at: '2026-10-19T16:12:00-03:00', label: 'Entrega', detail: 'A operadora confirmou a entrega.' },
    ],
  },
  {
    id: 'obs-sms-rejected',
    at: '2026-10-19T16:11:00-03:00',
    ...tea,
    channel: 'sms',
    campaignId: 'obs-sms-pontos',
    campaignName: 'Pontos perto de vencer',
    recipientMasked: '(11) 9••••-1104',
    kind: 'rejected',
    state: 'failed',
    cause: 'Número inexistente.',
    subject: 'Pontos perto de vencer',
    sequence: [
      { at: '2026-10-19T16:10:00-03:00', label: 'Envio', detail: 'SMS aceito para entrega.' },
      { at: '2026-10-19T16:11:00-03:00', label: 'Rejeição', detail: 'A operadora recusou o número.' },
    ],
  },
  {
    id: 'obs-sms-unsub',
    at: '2026-10-18T11:05:00-03:00',
    ...bom,
    channel: 'sms',
    campaignId: 'obs-sms-vip',
    campaignName: 'VIP de sexta',
    recipientMasked: '(21) 9••••-7730',
    kind: 'unsubscribed',
    state: 'success',
    cause: null,
    subject: 'VIP de sexta',
    sequence: [
      { at: '2026-10-18T10:40:00-03:00', label: 'Entrega', detail: 'A operadora confirmou a entrega.' },
      { at: '2026-10-18T11:05:00-03:00', label: 'Descadastro', detail: 'A pessoa pediu para sair da lista.' },
    ],
  },
  {
    id: 'obs-click',
    at: '2026-10-19T09:41:00-03:00',
    ...bom,
    campaignId: 'obs-ofertas',
    campaignName: 'Ofertas de outubro',
    recipientMasked: 'a•••@exemplo.com',
    kind: 'clicked',
    state: 'success',
    cause: null,
    subject: 'A oferta da semana na loja',
    sequence: [
      { at: '2026-10-19T08:58:00-03:00', label: 'Envio', detail: 'Mensagem aceita para entrega.' },
      { at: '2026-10-19T09:02:00-03:00', label: 'Entrega', detail: 'O provedor confirmou a entrega.' },
      { at: '2026-10-19T09:40:00-03:00', label: 'Abertura', detail: 'Aberta no celular.' },
      { at: '2026-10-19T09:41:00-03:00', label: 'Clique', detail: 'Clique no botão Ver oferta.' },
    ],
  },
  {
    id: 'obs-open',
    at: '2026-10-19T09:40:00-03:00',
    ...bom,
    campaignId: 'obs-ofertas',
    campaignName: 'Ofertas de outubro',
    recipientMasked: 'b•••@exemplo.com',
    kind: 'opened',
    state: 'success',
    cause: null,
    subject: 'A oferta da semana na loja',
    sequence: [
      { at: '2026-10-19T08:58:00-03:00', label: 'Envio', detail: 'Mensagem aceita para entrega.' },
      { at: '2026-10-19T09:02:00-03:00', label: 'Entrega', detail: 'O provedor confirmou a entrega.' },
      { at: '2026-10-19T09:40:00-03:00', label: 'Abertura', detail: 'Aberta no computador.' },
    ],
  },
  {
    id: 'obs-delivered',
    at: '2026-10-19T09:02:00-03:00',
    ...bom,
    campaignId: 'obs-ofertas',
    campaignName: 'Ofertas de outubro',
    recipientMasked: 'c•••@exemplo.com',
    kind: 'delivered',
    state: 'success',
    cause: null,
    subject: 'A oferta da semana na loja',
    sequence: [
      { at: '2026-10-19T08:58:00-03:00', label: 'Envio', detail: 'Mensagem aceita para entrega.' },
      { at: '2026-10-19T09:02:00-03:00', label: 'Entrega', detail: 'O provedor confirmou a entrega.' },
    ],
  },
  {
    id: 'obs-sent',
    at: '2026-10-19T08:58:00-03:00',
    ...bom,
    campaignId: 'obs-ofertas',
    campaignName: 'Ofertas de outubro',
    recipientMasked: 'c•••@exemplo.com',
    kind: 'sent',
    state: 'success',
    cause: null,
    subject: 'A oferta da semana na loja',
    sequence: [{ at: '2026-10-19T08:58:00-03:00', label: 'Envio', detail: 'Mensagem aceita para entrega.' }],
  },
  {
    id: 'obs-complaint',
    at: '2026-10-18T14:20:00-03:00',
    ...tea,
    campaignId: 'obs-cha',
    campaignName: 'Chá da primavera',
    recipientMasked: 'm•••@exemplo.com',
    kind: 'complained',
    state: 'failed',
    cause: 'O provedor marcou a mensagem como reclamação de spam.',
    subject: 'Novidade da casa de chá',
    sequence: [
      { at: '2026-10-18T11:00:00-03:00', label: 'Envio', detail: 'Mensagem aceita para entrega.' },
      { at: '2026-10-18T11:06:00-03:00', label: 'Entrega', detail: 'O provedor confirmou a entrega.' },
      { at: '2026-10-18T14:20:00-03:00', label: 'Reclamação', detail: 'Reclamação registrada pelo provedor.' },
    ],
  },
  {
    id: 'obs-unsub',
    at: '2026-10-18T11:05:00-03:00',
    ...pad,
    campaignId: 'obs-pao',
    campaignName: 'Pão quente de sexta',
    recipientMasked: 'r•••@exemplo.com',
    kind: 'unsubscribed',
    state: 'success',
    cause: null,
    subject: 'O pão quente de sexta',
    sequence: [
      { at: '2026-10-18T09:00:00-03:00', label: 'Envio', detail: 'Mensagem aceita para entrega.' },
      { at: '2026-10-18T09:04:00-03:00', label: 'Entrega', detail: 'O provedor confirmou a entrega.' },
      { at: '2026-10-18T10:12:00-03:00', label: 'Abertura', detail: 'Aberta no celular.' },
      { at: '2026-10-18T11:05:00-03:00', label: 'Descadastro', detail: 'A pessoa usou o link de um clique.' },
    ],
  },
  {
    id: 'obs-delay',
    at: '2026-10-17T16:40:00-03:00',
    ...tea,
    campaignId: 'obs-cha',
    campaignName: 'Chá da primavera',
    recipientMasked: 's•••@exemplo.com',
    kind: 'delayed',
    state: 'pending',
    cause: 'O provedor adiou a entrega e ainda não confirmou.',
    subject: 'Novidade da casa de chá',
    sequence: [
      { at: '2026-10-17T16:10:00-03:00', label: 'Envio', detail: 'Mensagem aceita para entrega.' },
      { at: '2026-10-17T16:40:00-03:00', label: 'Atraso', detail: 'Entrega adiada pelo provedor.' },
    ],
  },
  {
    id: 'obs-reject-mailbox',
    at: '2026-10-17T16:12:00-03:00',
    ...tea,
    campaignId: 'obs-cha',
    campaignName: 'Chá da primavera',
    recipientMasked: 't•••@exemplo.com',
    kind: 'rejected',
    state: 'failed',
    cause: 'Caixa inexistente. O endereço não recebe mensagem.',
    subject: 'Novidade da casa de chá',
    sequence: [
      { at: '2026-10-17T16:10:00-03:00', label: 'Envio', detail: 'Mensagem aceita para entrega.' },
      { at: '2026-10-17T16:12:00-03:00', label: 'Rejeição', detail: 'Caixa inexistente.' },
    ],
  },
  {
    id: 'obs-tea-delivered',
    at: '2026-10-16T10:04:00-03:00',
    ...tea,
    campaignId: 'obs-cha',
    campaignName: 'Chá da primavera',
    recipientMasked: 'u•••@exemplo.com',
    kind: 'delivered',
    state: 'success',
    cause: null,
    subject: 'Novidade da casa de chá',
    sequence: [
      { at: '2026-10-16T10:00:00-03:00', label: 'Envio', detail: 'Mensagem aceita para entrega.' },
      { at: '2026-10-16T10:04:00-03:00', label: 'Entrega', detail: 'O provedor confirmou a entrega.' },
    ],
  },
  {
    id: 'obs-padaria-open',
    at: '2026-10-15T09:30:00-03:00',
    ...pad,
    campaignId: 'obs-pao',
    campaignName: 'Pão quente de sexta',
    recipientMasked: 'v•••@exemplo.com',
    kind: 'opened',
    state: 'success',
    cause: null,
    subject: 'O pão quente de sexta',
    sequence: [
      { at: '2026-10-15T08:00:00-03:00', label: 'Envio', detail: 'Mensagem aceita para entrega.' },
      { at: '2026-10-15T08:05:00-03:00', label: 'Entrega', detail: 'O provedor confirmou a entrega.' },
      { at: '2026-10-15T09:30:00-03:00', label: 'Abertura', detail: 'Aberta no celular.' },
    ],
  },
  {
    id: 'obs-reject-domain',
    at: '2026-10-14T18:22:00-03:00',
    ...bom,
    campaignId: 'obs-cupom',
    campaignName: 'Cupom de terça',
    recipientMasked: 'w•••@exemplo.com',
    kind: 'rejected',
    state: 'failed',
    cause: 'O domínio do destinatário recusou a mensagem.',
    subject: 'Seu cupom de terça',
    sequence: [
      { at: '2026-10-14T18:20:00-03:00', label: 'Envio', detail: 'Mensagem aceita para entrega.' },
      { at: '2026-10-14T18:22:00-03:00', label: 'Rejeição', detail: 'Domínio do destinatário recusou.' },
    ],
  },
  {
    id: 'obs-welcome',
    at: '2026-10-12T08:10:00-03:00',
    ...bom,
    campaignId: 'obs-boas-vindas',
    campaignName: 'Boas-vindas da semana',
    recipientMasked: 'y•••@exemplo.com',
    kind: 'sent',
    state: 'success',
    cause: null,
    subject: 'Bem-vindo à loja',
    sequence: [{ at: '2026-10-12T08:10:00-03:00', label: 'Envio', detail: 'Mensagem aceita para entrega.' }],
  },
  {
    id: 'obs-old',
    at: '2026-10-08T12:00:00-03:00',
    ...tea,
    campaignId: 'obs-cha',
    campaignName: 'Chá da primavera',
    recipientMasked: 'z•••@exemplo.com',
    kind: 'sent',
    state: 'success',
    cause: null,
    subject: 'Novidade da casa de chá',
    sequence: [{ at: '2026-10-08T12:00:00-03:00', label: 'Envio', detail: 'Mensagem aceita para entrega.' }],
  },
];
